var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWorkspaces(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    viewBox: "0 0 490.667 490.667",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M245.333,0c-5.888,0-10.667,4.779-10.667,10.667v298.667c0,5.888,4.779,10.667,10.667,10.667S256,315.221,256,309.333    V10.667C256,4.779,251.221,0,245.333,0z",
    fill: "#000000",
    "data-original": "#000000",
    className: ""
  }))), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M480,213.333h-85.333c-5.888,0-10.667,4.779-10.667,10.667s4.779,10.667,10.667,10.667H480    c5.888,0,10.667-4.779,10.667-10.667S485.888,213.333,480,213.333z",
    fill: "#000000",
    "data-original": "#000000",
    className: ""
  }))), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M309.333,213.333h-128c-5.888,0-10.667,4.779-10.667,10.667s4.779,10.667,10.667,10.667h128    c5.888,0,10.667-4.779,10.667-10.667S315.221,213.333,309.333,213.333z",
    fill: "#000000",
    "data-original": "#000000",
    className: ""
  }))), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M96,213.333H10.667C4.779,213.333,0,218.112,0,224s4.779,10.667,10.667,10.667H96c5.888,0,10.667-4.779,10.667-10.667    S101.888,213.333,96,213.333z",
    fill: "#000000",
    "data-original": "#000000",
    className: ""
  }))), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M245.333,384c-5.888,0-10.667,4.779-10.667,10.667V480c0,5.888,4.779,10.667,10.667,10.667S256,485.888,256,480v-85.333    C256,388.779,251.221,384,245.333,384z",
    fill: "#000000",
    "data-original": "#000000",
    className: ""
  }))), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M480,0H10.667C4.779,0,0,4.779,0,10.667v298.667C0,315.2,4.779,320,10.667,320H32c5.888,0,10.667-4.779,10.667-10.667    S37.888,298.667,32,298.667H21.333V21.333h448v448h-448v-64H32c5.888,0,10.667-4.779,10.667-10.667S37.888,384,32,384H10.667    C4.779,384,0,388.779,0,394.667V480c0,5.888,4.779,10.667,10.667,10.667H480c5.888,0,10.667-4.779,10.667-10.667V10.667    C490.667,4.779,485.888,0,480,0z",
    fill: "#000000",
    "data-original": "#000000",
    className: ""
  }))), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M266.667,298.667H224c-5.888,0-10.667,4.779-10.667,10.667S218.112,320,224,320h42.667    c5.888,0,10.667-4.779,10.667-10.667S272.555,298.667,266.667,298.667z",
    fill: "#000000",
    "data-original": "#000000",
    className: ""
  }))), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M266.667,384H224c-5.888,0-10.667,4.779-10.667,10.667s4.779,10.667,10.667,10.667h42.667    c5.888,0,10.667-4.779,10.667-10.667S272.555,384,266.667,384z",
    fill: "#000000",
    "data-original": "#000000",
    className: ""
  }))), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M96,192c-5.888,0-10.667,4.779-10.667,10.667v42.667C85.333,251.221,90.112,256,96,256s10.667-4.779,10.667-10.667    v-42.667C106.667,196.779,101.888,192,96,192z",
    fill: "#000000",
    "data-original": "#000000",
    className: ""
  }))), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M181.333,192c-5.888,0-10.667,4.779-10.667,10.667v42.667c0,5.888,4.779,10.667,10.667,10.667S192,251.221,192,245.333    v-42.667C192,196.779,187.221,192,181.333,192z",
    fill: "#000000",
    "data-original": "#000000",
    className: ""
  }))), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M309.333,192c-5.888,0-10.667,4.779-10.667,10.667v42.667c0,5.888,4.779,10.667,10.667,10.667S320,251.221,320,245.333    v-42.667C320,196.779,315.221,192,309.333,192z",
    fill: "#000000",
    "data-original": "#000000",
    className: ""
  }))), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M394.667,192c-5.888,0-10.667,4.779-10.667,10.667v42.667c0,5.888,4.779,10.667,10.667,10.667s10.667-4.779,10.667-10.667    v-42.667C405.333,196.779,400.555,192,394.667,192z",
    fill: "#000000",
    "data-original": "#000000",
    className: ""
  }))), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWorkspaces);
export default __webpack_public_path__ + "static/media/icon_workspaces.a188e646c46bc0d236ec3bb33df2949b.svg";
export { ForwardRef as ReactComponent };